import Footer from "../../home/components/Footer";
import QRCode from "react-qr-code";
import "../styles/Success.css";
import dtpclogo from "../../../images/dtpclogo.png"

function BookingSuccess({ details }) {
    const totalAdultsPrice = details.counts.adults * details.slotDetails.adultPrice;
    const totalChildrenPrice = details.counts.children * details.slotDetails.childPrice;
    const totalCameraPrice = details.counts.camera * details.slotDetails.videoCameraPrice;
    const totalPrice = totalAdultsPrice + totalChildrenPrice + totalCameraPrice;

    function handlePrintPDF() {
        const button = document.querySelector(".print-pdf-button");

        button.style.display = "none";
        window.print();
        button.style.display = "block";
    }

    return (
        <div>
            <div className='confirmation'>
                <img src={dtpclogo} alt="DTPC Logo" className="dtpc-logo" />
                <div className='confirmation-header'>
                    <h2>
                        Booking Confirmation <br />
                        <span className='booking-id'>#{details.bookingId}</span>
                    </h2>
                    <button className='print-pdf-button' onClick={handlePrintPDF}>
                        Print/Save PDF
                    </button>
                </div>

                <table className='booking-table'>
                    <tbody>
                        <tr>
                            <td>
                                <div className='success-slot-details'>
                                    <h3>Slot Information</h3>
                                    <p>Date: {details.date}</p>
                                    <p>Slot: {details.slot}</p>
                                    <p>Time: {details.slotDetails.time}</p>
                                </div>
                            </td>
                            <td>
                                <div className='contact-details'>
                                    <h3>Contact Details</h3>
                                    <p>Name: {details.name}</p>
                                    <p>Phone: {details.phone}</p>
                                    <p>Email: {details.email}</p>
                                </div>

                            </td>

                        </tr>
                    </tbody>
                </table>


                <table className='billing-table'>
                    <thead>
                        <tr>
                            <th>Details</th>
                            <th>Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Adults ({details.counts.adults} x ₹{details.slotDetails.adultPrice})</td>
                            <td>₹{totalAdultsPrice}</td>
                        </tr>
                        <tr>
                            <td>Children ({details.counts.children} x ₹{details.slotDetails.childPrice})</td>
                            <td>₹{totalChildrenPrice}</td>
                        </tr>
                        <tr>
                            <td>Video Camera ({details.counts.camera} x ₹{details.slotDetails.videoCameraPrice})</td>
                            <td>₹{totalCameraPrice}</td>
                        </tr>
                        <tr className='total'>
                            <td>Total</td>
                            <td>₹{totalPrice}</td>
                        </tr>
                    </tbody>
                </table>
                <p className='booking-date'>Booking Date: {details.bookingDate} ({details.bookingTimestamp})</p>
                <div className='qr-code'>
                    <QRCode
                        value={"https://edakkalcaves.web.app/ticket/" + details.bookingId}
                        size={200}
                    />
                </div>
            </div>
            <Footer showIcons={false} />
        </div>
    );
}

export default BookingSuccess;